module.exports = __webpack_public_path__ + "img/doc_1_preview.7ab79f61.jpg";